var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overview-container"},_vm._l((_vm.permissionItems),function(permissionItem){return _c('RolePermissionsOverviewItem',{key:permissionItem.title,attrs:{"permission-item":permissionItem,"permissions":_vm.permissions}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }